import { render, staticRenderFns } from "./EditForecastHistoryModal.vue?vue&type=template&id=28c23806"
import script from "./EditForecastHistoryModal.vue?vue&type=script&lang=js"
export * from "./EditForecastHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports